import React, { lazy } from "react";
import Page from "components/Page";
import { Props } from "./PendingGuarantees";

const PendingGuarantees = lazy(() => import("./PendingGuarantees"));

export default (props: Props) => (
  <Page>
    <PendingGuarantees {...props} />
  </Page>
);
